module.exports = __webpack_public_path__ + "HRA Poster - After participant portion.pdf";